import { useSnackbar } from "notistack";
import { useCallback, useState } from "react";

import { AjaxResult } from "../../../../../enums/ajaxResult";
import { useApi } from "../../../../useApi";

export function useRemoveOwner(boxId: number) {
    const { boxApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const removeOwner = useCallback((ownerId: number, onSuccess: () => void) => {
        setLoading(true);
        boxApi.removeOwner(boxId, ownerId).then((r) => {
            if (r.result === AjaxResult.Success) {
                enqueueSnackbar("Owner removed!", { variant: "success" });
                onSuccess();
            } else {
                enqueueSnackbar("Failed to remove owner!", { variant: "error" });
            }
            setLoading(false);
        });
    }, [boxApi, boxId, enqueueSnackbar]);

    return { removeOwner, loading };
}
